import React from 'react'

export const HTML = ({innerHtml}) => {
  return <div dangerouslySetInnerHTML={{ __html: innerHtml }}></div>
}
